<ng-container>
  <div>
    <ng-container
      *ngIf="
        (currentCountry === 'nl' || currentCountry === 'fr') && (isNewBusinessDetailsDesignEnabled$ | async)
      "
    >
      <div class="info-text">
        {{ 'PAGES.AUTH.REGISTRATION.ADD_BUSINESS_DETAILS.INFO_TEXT' | translate }}
      </div>
      <label class="selected-branch">
        <div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48539 0 0 4.48566 0 9.99939C0 15.5143 4.48539 20 10 20C15.5146 20 20 15.5143 20 9.99939C20 4.48566 15.5146 0 10 0ZM10 18.1815C5.48794 18.1815 1.8184 14.5117 1.8184 9.99939C1.8184 5.48827 5.48794 1.81851 10 1.81851C14.5108 1.81851 18.1816 5.48827 18.1816 9.99939C18.1816 14.5117 14.5108 18.1815 10 18.1815ZM14.6853 6.48681C14.2984 6.14283 13.7058 6.17769 13.3618 6.56467L9.02236 11.4465L6.60041 9.0246C6.2343 8.65848 5.6407 8.65848 5.27459 9.0246C4.90847 9.39071 4.90847 9.98431 5.27459 10.3504L8.39959 13.4754C8.78101 13.8568 9.40483 13.8385 9.7632 13.4354L14.7632 7.81035C15.1072 7.42337 15.0723 6.8308 14.6853 6.48681Z" fill="#24865B"/>
          </svg>
        </div>
        <div class="selected-branch__text-wrapper">
          <h4 class="selected-branch__title">{{ branch?.businessName.toUpperCase() }}</h4>
          <p *ngIf="branch?.kvkNumber" class="selected-branch__description">
            {{ 'REGULAR.FIELDS.KVK_NUMBER_FOR_TIER_TWO_SIGNUP.LABEL' | translate }}:
            {{ branch?.kvkNumber }}
          </p>
          <p *ngIf="branch?.branchNumber && currentCountry === 'nl'" class="selected-branch__description">
            {{ 'PAGES.AUTH.REGISTRATION.BRANCH_SELECTION.BRANCH_NUMBER' | translate }}:
            {{ branch?.branchNumber }}
          </p>
          <p *ngIf="branch?.branchNumber && currentCountry === 'fr'" class="selected-branch__description">
            {{ 'PAGES.AUTH.REGISTRATION.BRANCH_SELECTION.SIRET_NUMBER' | translate }}:
            {{ branch?.siret }}
          </p>
          <p class="selected-branch__description">
            {{ branch?.legalAddressStreet }} {{ branch?.legalAddressBuildingNumber }}
            {{ branch?.legalAddressCity }}
          </p>
          <p class="selected-branch__description">
            {{ branch?.legalAddressPostalCode }}, {{ currentCountry.toUpperCase() }}
          </p>
        </div>
        <div>
          <svg [mmTooltip]="tooltipInfoText" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.98188" cy="8.01814" r="7.01813" fill="#0064FE" stroke="#0064FE" stroke-width="1.00259" />
            <path
              d="M8.51577 6.2461V12.3398H7.445V6.2461H8.51577ZM8.74436 4.33315C8.74436 4.43742 8.7223 4.53568 8.67819 4.62792C8.63809 4.71614 8.58194 4.79635 8.50975 4.86854C8.44158 4.93671 8.35937 4.99085 8.26312 5.03096C8.17088 5.07106 8.07262 5.09111 7.96836 5.09111C7.86409 5.09111 7.76583 5.07106 7.67359 5.03096C7.58537 4.99085 7.50716 4.93671 7.43899 4.86854C7.37081 4.79635 7.31667 4.71614 7.27657 4.62792C7.23646 4.53568 7.21641 4.43742 7.21641 4.33315C7.21641 4.22888 7.23646 4.13063 7.27657 4.03839C7.31667 3.94214 7.37081 3.85993 7.43899 3.79176C7.50716 3.71957 7.58537 3.66342 7.67359 3.62332C7.76583 3.58322 7.86409 3.56316 7.96836 3.56316C8.07262 3.56316 8.17088 3.58322 8.26312 3.62332C8.35937 3.66342 8.44158 3.71957 8.50975 3.79176C8.58194 3.85993 8.63809 3.94214 8.67819 4.03839C8.7223 4.13063 8.74436 4.22888 8.74436 4.33315Z"
              fill="white" />
          </svg>
          <ng-template #tooltipInfoText>
            {{ 'PAGES.AUTH.REGISTRATION.ADD_BUSINESS_DETAILS.TOOLTIP_INFO_TEXT' | translate }}
          </ng-template>
        </div>
      </label>

      <hr class="divider" />
    </ng-container>
  </div>

  <app-advanced-form
    class="tier-two-business-details"
    [config]="advancedFormConfig"
    [isFieldDisabled]="isFieldDisabled"
    (events)="onAdvancedFormEvents($event)"
  >
  </app-advanced-form>

  <div class="tier-two-business-details__legal-text">
    <span [innerHTML]="'PAGE.AUTH.PASSWORDLESS_SIGNUP.ADD_BUSINESS_DETAILS.METRO.TNC' | translate"></span>
  </div>
</ng-container>
